<template>
  <div class="sinfo_list">
    <div
      class="content_list"
      v-for="(item, index) in infoList"
      :key="index"
      @click="showDetail(item)"
    >
      <p class="content_list_firstp">·</p>
      <p class="content_list_lastp">{{ item.newsTitle }}</p>
      <span>{{ item.publishTimeWeb }}</span>
    </div>
    <div style="text-align: center; margin: 20px 0">
      <el-pagination
        v-if="page_size > 7"
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page_size"
        :layout="layout"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { apiRequest } from "../../../api/api.js";
import { setVideoRecord, getIntegralUrl } from "@/api/moudles/home.js";
export default {
  data() {
    return {
      infoList: [],
      searchValue: "",
      currentPage: 1,
      totalNum: 0,
      columnCode: "",
      layout: "total, sizes, prev, pager, next, jumper",
    };
  },
  props: {
    column_code: {
      type: String,
      default: "",
    },
    page_size: {
      type: Number,
      default: 10,
    },
  },
  watch: {
    column_code(newValue) {
      this.columnCode = newValue;
      this.getInformation(newValue, 1, this.page_size, "1");
    },
  },
  created() {
    const screenWidth = window.screen.width;
    if (screenWidth < 760) {
      this.layout = "prev, pager, next";
    }
    if (screenWidth > 760) {
      this.layout = "total, sizes, prev, pager, next, jumper";
    }
  },
  mounted() {
    this.$bus.$on("search", (res) => {
      console.log("监听", res);
      this.searchValue = res.value;
      this.getInformation(this.columnCode, 1, this.page_size, "1");
    });
  },
  beforeDestroy() {
    this.$bus.$off("search");
  },
  methods: {
    handleSizeChange(val) {
      this.page_size = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInformation(this.columnCode, val, this.page_size, "1");
    },
    async showDetail(item) {
      const token = this.$store.state.user.token;
      if (item.points > 0 && !token) {
        this.$message("请先登录后再查看！");
      } else if (item.points == 0) {
        if (item.wxLink) {
          window.open(item.wxLink);
        } else {
          this.$emit("activeList");
          const screenWidth = window.screen.width;
          if (screenWidth < 760) {
            this.$router.push(`/phoneIndex/info/detail/${item.id}`);
          } else {
            this.$router.push(`/info/detail/${item.id}`);
          }
        }
        this.setVideoRecord("1", item.id);
      } else {
        await getIntegralUrl({
          data: {
            type: "news",
            id: item.id,
          },
          success: (res) => {
            if (res.data) {
              window.open(res.data);
              this.setVideoRecord("1", item.id);
            } else {
              this.$message(res.msg);
            }
          },
        });
      }
    },
    // 提交视频播放记录
    async setVideoRecord(type, newsId) {
      await setVideoRecord({
        data: {
          type,
          newsId,
          userId: "",
        },
      });
    },
    // 获取栏目资讯列表
    async getInformation(column_code, pageNo, pageSize, model) {
      await apiRequest({
        method: "get",
        url: "/app-api/website/news/get-web-news-list",
        data: {
          columnCode: column_code,
          pageNo,
          pageSize,
          model,
          newsTitle: this.searchValue,
        },
        success: (res) => {
          // console.log('resdata',res.data)
          this.infoList = res.data.list;
          this.totalNum = parseInt(res.data.total);
        },
      });
    },
  },
};
</script>

<style scoped>
.sinfo_list {
  /* width: 506px; */
}

.sinfo_list_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.sinfo_list_head p {
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #131415;
  letter-spacing: 0;
  font-weight: 600;
}

.big_title_box {
  min-width: 100px;
  display: flex;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}

.big_title_p {
  min-width: 100px;
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #131415;
  letter-spacing: 0;
  text-align: center;
  font-weight: 600;
  margin-left: 15px;
}

/* 咨询列表-可复用 */
.content_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 20px;
  border-bottom: 2px dotted #f5f5f5;
}

.content_list p:hover {
  color: #015aaa;
  text-decoration: underline;
  cursor: pointer;
}

.content_list_firstp {
  font-size: 35px;
}

.content_list_lastp {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 24px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 120px);
}

.content_list span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 24px;
  font-weight: 400;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 120px;
}

.sinfo_list_head_span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d40d16;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
}

.sinfo_list_head_span:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
